export const Remove = (props: React.SVGProps<SVGSVGElement>) => (
	<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className="w-full" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
			fill="currentColor"
		/>
		<path
			d="M15.7511 14.5509C16.083 14.8829 16.083 15.4193 15.7511 15.7513C15.5856 15.9168 15.3683 16 15.1509 16C14.9336 16 14.7163 15.9168 14.5507 15.7513L12 13.2003L9.44926 15.7513C9.28373 15.9168 9.06644 16 8.84915 16C8.6317 16 8.41441 15.9168 8.24888 15.7513C7.91704 15.4193 7.91704 14.8829 8.24888 14.5509L10.7998 12.0001L8.24888 9.44929C7.91704 9.11729 7.91704 8.58089 8.24888 8.24889C8.58088 7.91704 9.11726 7.91704 9.44926 8.24889L12 10.7998L14.5507 8.24889C14.8827 7.91704 15.4191 7.91704 15.7511 8.24889C16.083 8.58089 16.083 9.11729 15.7511 9.44929L13.2002 12.0001L15.7511 14.5509Z"
			fill="currentColor"
		/>
	</svg>
);
